module.exports = __webpack_public_path__ + "static/4-commands-2c2ef8f23dd02504eb17b29bf5fca32a.png";